import apiSlice from "../api/apiSlice";

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userList: builder.mutation({
      query: () => ({
        url: "/admin/user/list",
        method: "POST",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    userInfo: builder.query({
      query: (id) => ({
        url: `/user/view/${id}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),

    // create subadmin
    createSubadmin: builder.mutation({
      query: (data) => ({
        url: `/subadmin/add-new`,
        body: data,
        method: "POST",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    updateSubadmin: builder.mutation({
      query: (data) => ({
        url: `/subadmin/update`,
        body: data,
        method: "POST",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),

    deleteSubadmin: builder.mutation({
      query: (id) => ({
        url: `/subadmin/remove/${id}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    approveKyc: builder.mutation({
      query: ({ id, page }) => ({
        url: `/user/approve-kyc/${id}/${page}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    rejectKyc: builder.mutation({
      query: ({ id, page, reason }) => ({
        url: `/user/reject-kyc/${id}/${page}`,
        method: "POST",
        body: { "reason": reason },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    getSubadminList: builder.query({
      query: () => ({
        url: `/subadmin/list`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    getSingleSubadminDetails: builder.query({
      query: (id) => ({
        url: `/subadmin/details/${id}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    getUniqueId: builder.query({
      query: () => ({
        url: `/unique_id`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    // getAllNft: builder.query({
    //   query: () => ({
    //     url: `/admin/shownft`,
    //     method: "POST",
    //     headers: {
    //       tag: "admin",
    //       Authorization: `${localStorage.getItem("token")}`,
    // "x-client-ip": `${localStorage.getItem("ip")}`
    //     },
    //   }),
    // }),
    // getSingleUserNft: builder.query({
    //   query: (id) => ({
    //     url: `/admin/shownft`,
    //     method: "POST",
    //     body: { id },
    //     headers: {
    //       tag: "admin",
    //       Authorization: `${localStorage.getItem("token")}`,
    // "x-client-ip": `${localStorage.getItem("ip")}`
    //     },
    //   }),
    // }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/user/delete/${id}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    //settings
    settings: builder.mutation({
      query: () => ({
        url: `/site/list`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    updateSettings: builder.mutation({
      query: (_id) => ({
        url: `/site/update`,
        method: "POST",
        body: _id,
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    //transctionhistory
    transctionhistory: builder.mutation({
      query: () => ({
        url: `/admin/transcationshistory`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    singletransctionhistory: builder.mutation({
      query: (_id) => ({
        url: `/admin/viewtranscations/${_id}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    //user showtranscationhistory 
    userShowtranscationhistory: builder.query({
      query: (id) => ({
        url: `/admin/showtranscationshistory`,
        body: { id },
        method: "POST",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    // unblock/block user (toggle)
    // Keeping the original endpoint but exposing a clearer-named hook
    toggleUserStatus: builder.mutation({
      query: ({ id }) => ({
        url: `/user/change/${id}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    changeMode: builder.mutation({
      query: ({ id, mode }) => ({
        url: `/admin/changemode/${id}`,
        method: "POST",
        body: { mode },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    // Uploading doc

    uploadexcel: builder.mutation({
      query: (data) => ({
        url: `/upload-excelfile`,
        method: "POST",
        body: data,
        headers: {
          tag: "admin",
          Origin: "https://mycryptosep.com",
          // "Content-Type": "multipart/form-data",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    // ROI history
    roiHistory: builder.query({
      query: () => ({
        url: "/getroireport",
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    changeKyc: builder.mutation({
      query: ({ id, page, body }) => ({
        url: `/user/change-kyc/${id}/${page}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    portfolio: builder.query({
      query: ({ id, portfolio = 1 }) => ({
        url: `/admin/getportfolio/${id}`,
        method: "POST",
        body: { portfolio: portfolio },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    subscribeDetailsById: builder.query({
      query: (id) => ({
        url: `/admin/getusersubscribeDetails/${id}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    subscribeDetailsByUserId: builder.query({
      query: (id) => ({
        url: `/admin/getsubscribeDetails/${id}`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    getAllTickets: builder.query({
      query: () => ({
        url: `/support-ticket/raised`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    ticketDetails: builder.query({
      query: (ticketId) => ({
        url: `/support-ticket/details`,
        method: "POST",
        body: { ticketId },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    adminReplay: builder.mutation({
      query: ({ ticket_id, message }) => ({
        url: `/user/new_message_admin`,
        method: "POST",
        body: { ticket_id, message },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    closeTicket: builder.mutation({
      query: (ticket_id) => ({
        url: `/admin/close-ticket`,
        method: "POST",
        body: { ticket_id },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    listEnquiry: builder.query({
      query: () => ({
        url: `/list-enquiry`,
        method: "GET",
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    subscribeDetails: builder.mutation({
      query: (planname) => ({
        url: `/admin/getsubscribeDetails`,
        method: "POST",
        body: { planname },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    fiatDetails: builder.mutation({
      query: (type) => ({
        url: `/admin/list/fiat`,
        method: "POST",
        body: { category: type || "deposit" },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    fiatApprove: builder.mutation({
      query: (transactionId) => ({
        url: `/subscribe/approve`,
        method: "POST",
        body: { transactionId, "x-client-ip": `${localStorage.getItem("ip")}` },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    fiatReject: builder.mutation({
      query: ({ transactionId, remarks }) => ({
        url: `/subscribe/reject`,
        method: "POST",
        body: { transactionId, remarks, "x-client-ip": `${localStorage.getItem("ip")}` },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    approveEnquiry: builder.mutation({
      query: (enquiryId) => ({
        url: `/approve_enquery`,
        method: "POST",
        body: { enquiryId, "x-client-ip": `${localStorage.getItem("ip")}` },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
    rejectEnquiry: builder.mutation({
      query: ({ enquiryId, reason }) => ({
        url: `/reject_enquery`,
        method: "POST",
        body: { enquiryId, reason, "x-client-ip": `${localStorage.getItem("ip")}` },
        headers: {
          tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
          "x-client-ip": `${localStorage.getItem("ip")}`
        },
      }),
    }),
  }),

});

export const {
  useUserListMutation,
  useUserInfoQuery,
  useUserDeleteQuery,
  useListEnquiryQuery,
  usePortfolioQuery,
  useGetAllTicketsQuery,
  useTicketDetailsQuery,
  useAdminReplayMutation,
  useCloseTicketMutation,
  useSubscribeDetailsMutation,
  useSubscribeDetailsByIdQuery,
  useSubscribeDetailsByUserIdQuery,
  useCreateSubadminMutation,
  useApproveKycMutation,
  useRejectKycMutation,
  useUpdateSubadminMutation,
  useGetSubadminListQuery,
  useGetUniqueIdQuery,
  useGetAllNftQuery,
  useGetSingleUserNftQuery,
  useGetSingleSubadminDetailsQuery,
  useDeleteSubadminMutation,
  useDeleteUserMutation,
  useSettingsMutation,
  useUpdateSettingsMutation,
  useUnblockblockUserMutation,
  useToggleUserStatusMutation,
  useTransctionhistoryMutation,
  useSingletransctionhistoryMutation,
  useUserShowtranscationhistoryQuery,
  useChangeModeMutation,
  useRoiHistoryQuery,
  useChangeKycMutation,
  useUploadexcelMutation,
  useFiatDetailsMutation,
  useFiatApproveMutation,
  useFiatRejectMutation,
  useApproveEnquiryMutation,
  useRejectEnquiryMutation,
  useUploadMutation,
} = userApi;
